import { Page } from '../../direct-flow/types'

import { lazyWithRetry } from 'utils/lazyWithRetry'

const Registration = lazyWithRetry(() =>
  import('../../direct-flow/pages/Registration').then((module) => ({
    default: module.Registration,
  })),
)
const ManualVehicleLookup = lazyWithRetry(() =>
  import('../../direct-flow/pages/ManualVehicleLookup/ManualVehicleLookup').then((module) => ({
    default: module.ManualVehicleLookup,
  })),
)

const VehicleFound = lazyWithRetry(() =>
  import('../../direct-flow/pages/VehicleFound').then((module) => ({
    default: module.VehicleFound,
  })),
)

const Licence = lazyWithRetry(() =>
  import('../../direct-flow/pages/Licence').then((module) => ({
    default: module.Licence,
  })),
)
const Drivers = lazyWithRetry(() =>
  import('../../direct-flow/pages/Drivers').then((module) => ({
    default: module.Drivers,
  })),
)
const Vehicle = lazyWithRetry(() =>
  import('../../direct-flow/pages/Vehicle').then((module) => ({
    default: module.Vehicle,
  })),
)

const History = lazyWithRetry(() =>
  import('../../direct-flow/pages/History').then((module) => ({
    default: module.History,
  })),
)

const ClaimFreeDiscount = lazyWithRetry(() =>
  import('../../direct-flow/pages/ClaimFreeDiscount').then((module) => ({
    default: module.ClaimFreeDiscount,
  })),
)

const PreviousCancellation = lazyWithRetry(() =>
  import('../../direct-flow/pages/PreviousCancellation').then((module) => ({
    default: module.PreviousCancellation,
  })),
)

const PreviousCancellationYear = lazyWithRetry(() =>
  import('../../direct-flow/pages/PreviousCancellationYear').then((module) => ({
    default: module.PreviousCancellationYear,
  })),
)

const Usage = lazyWithRetry(() =>
  import('../../direct-flow/pages/Usage').then((module) => ({
    default: module.Usage,
  })),
)

const PolicyStartDate = lazyWithRetry(() =>
  import('../../direct-flow/pages/PolicyStartDate').then((module) => ({
    default: module.PolicyStartDate,
  })),
)
const EditDetails = lazyWithRetry(() =>
  import('../../direct-flow/pages/EditDetails').then((module) => ({
    default: module.EditDetails,
  })),
)

const createRoutes = (prefixRoute: 'direct' | 'edit') => {
  return [
    {
      name: Page.REGISTRATION,
      path: `/${prefixRoute}/:quoteId/registration`,
      component: <Registration />,
    },
    {
      name: Page.MVL,
      path: `/${prefixRoute}/:quoteId/manual-lookup`,
      component: <ManualVehicleLookup />,
    },
    {
      name: Page.VEHICLE_FOUND,
      path: `/${prefixRoute}/:quoteId/vehicle-found`,
      component: <VehicleFound />,
    },
    {
      name: Page.LICENCE,
      path: `/${prefixRoute}/:quoteId/licence`,
      component: <Licence />,
    },
    {
      name: Page.DRIVERS,
      path: `/${prefixRoute}/:quoteId/drivers`,
      component: <Drivers />,
    },
    {
      name: Page.VEHICLE,
      path: `/${prefixRoute}/:quoteId/vehicle`,
      component: <Vehicle />,
    },
    {
      name: Page.HISTORY,
      path: `/${prefixRoute}/:quoteId/history`,
      component: <History />,
    },
    {
      name: Page.CLAIM_FREE_DISCOUNT,
      path: `/${prefixRoute}/:quoteId/claim-free-discount`,
      component: <ClaimFreeDiscount />,
    },
    {
      name: Page.PREVIOUS_CANCELLATION,
      path: `/${prefixRoute}/:quoteId/previous-cancellation`,
      component: <PreviousCancellation />,
    },
    {
      name: Page.PREVIOUS_CANCELLATION_YEAR,
      path: `/${prefixRoute}/:quoteId/previous-cancellation-year`,
      component: <PreviousCancellationYear />,
    },
    {
      name: Page.USAGE,
      path: `/${prefixRoute}/:quoteId/usage`,
      component: <Usage />,
    },
    {
      name: Page.POLICY_START_DATE,
      path: `/${prefixRoute}/:quoteId/policy-start-date`,
      component: <PolicyStartDate />,
    },
    {
      name: Page.EDIT_DETAILS,
      path: `/${prefixRoute}/:quoteId/details`,
      component: <EditDetails />,
    },
  ] as const
}

export const directRoutes = createRoutes('direct')
export const postQuoteEditRoutes = createRoutes('edit')
